import { render, staticRenderFns } from "./RequestInspection.vue?vue&type=template&id=8ffa36e2"
import script from "./RequestInspection.vue?vue&type=script&lang=js"
export * from "./RequestInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports